import { ColDef } from '@ag-grid-community/core';
import { AgGridReact } from '@ag-grid-community/react';
import { DocRenderer } from '@cyntler/react-doc-viewer';
import Papa, { ParseResult } from 'papaparse';
import { useEffect, useState } from 'react';

const tableContainerStyle = {
  height: '100vh',
  width: '100vw',
  marginTop: '60px',
  backgroundColor: 'white',
};
type RowData = Record<string, string | number | boolean>;
export const CsvRenderer: DocRenderer = ({ mainState }) => {
  const { currentDocument } = mainState;

  const [data, setData] = useState<RowData[] | undefined>(undefined);
  const [columns, setColumns] = useState<ColDef[]>([]);

  useEffect(() => {
    const parseData = async () => {
      const fileUrl = currentDocument?.uri || '';

      const blob = await fetch(fileUrl).then((res) => res.blob());
      const fileBlob = new File([blob], currentDocument?.fileName || '');

      Papa.parse(fileBlob, {
        header: true,
        dynamicTyping: true,
        complete: handleDataChange,
      });
    };

    parseData();

    return () => {
      setData(undefined);
      setColumns([]);
    };
  }, [currentDocument?.uri]);

  const makeColumns = (rawColumns: string[]): ColDef[] => {
    return rawColumns.map((column) => {
      return {
        field: column,
        sortable: true,
        minWidth: 150,
        resizable: true,
      };
    });
  };

  const handleDataChange = (file: ParseResult<RowData>) => {
    setColumns(makeColumns(file.meta.fields || []));
    setData(file.data);
  };

  return (
    <div className="ag-theme-portal" style={tableContainerStyle}>
      <AgGridReact
        rowHeight={30}
        headerHeight={30}
        rowData={data}
        columnDefs={columns}
        gridOptions={{
          enableCellTextSelection: true,
          defaultColDef: {
            flex: 1,
            minWidth: 100,
          },
        }}
      />
    </div>
  );
};

CsvRenderer.fileTypes = ['text/csv'];
CsvRenderer.weight = 1;
